module.exports = __webpack_public_path__ + "img/prop-horse.f04cef64.webp";